<template>
  <div :class="$style.card">
    <p>{{ brand.name }}</p>
    <img
      :src="brand.logo"
      :class="$style.image"
    >
  </div>
</template>

<script>
export default {
  props: {
    brand: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" module>
.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 250px;
  padding: 25px 20px;
  cursor: pointer;

  &:hover,
  &:focus {
    background-color: #f0f8ff;
    border-radius: 10px;
  }
}

.image {
  width: 60px;
  object-fit: contain;
}
</style>
